module.exports = __webpack_public_path__ + "img/img11.7d2c9561.jpg";